import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

export const SEND_SIGN_UP_EMAIL_FOR_MEMBER = gql`
  mutation ($memberId: ObjectId!) {
    sendSignUpEmailForMember(memberId: $memberId)
  }
`;

export const useSendSignUpEmailForMember = (memberId?: string) => {
  const { t } = useTranslation(['auth']);

  const [sendSignUpEmailForMember] = useMutation(SEND_SIGN_UP_EMAIL_FOR_MEMBER, {
    variables: { memberId },
    onCompleted: () =>
      showNotification({
        type: NOTIFICATION_TYPE.success,
        message: t('auth:titles.signupEmailResent'),
      }),
  });

  return sendSignUpEmailForMember;
};
